/**
 *
 * GridCard
 *
 */

import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Div, PayOff, ContainerFlex, Video } from '../Blocks'
import media from '../../style/mediainjector'
import LazyLoadedMedia from '../LazyLoadedMedia'
import { getIsVideoFromUrl } from '../../utils/tools'

export const GridCardContainer = styled(ContainerFlex)`
  align-items: stretch;
  padding: 0;
  ${media.lt667`
    flex-direction: column;
  `}
  ${media.mobile`
    padding: 0 40px;
  `}
  ${media.lt667`
    padding: 0 20px;
  `}
`

export const VideoCard = styled(Video)`
  ${media.lt667`
    margin: 30px auto;
  `}
`

export const GridCardBlock = styled(Div)`
  display: flex;
  width: ${({ fullWidth }) => !fullWidth && '50%'};
  flex-direction: column;
  justify-content: space-between;
  ${media.gt667`
    &:first-child {
      padding-right: 18px;
    }
    &:last-child {
      padding-left: 18px;
    }
  `}
  order: ${(props) => props.flexorder};
  ${media.lt667`
    width: 100%;
  `}
  ul {
    padding: 0;
    margin: 0;
    h3,
    h4 {
      font-size: 2.4rem;
      margin: 0 0 12px;
    }
    li {
      list-style: none;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      padding: 32px 0;
      &:first-child {
        border-top: none;
        padding-top: 0;
      }
      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }
    }
  }
`

export const Image = styled.img`
  width: 100%;
  display: block;
  margin: 0 auto;
  ${media.lt667`
    width: 100%;
    padding: 18px;
  `}
`

class GridCard extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function
  render() {
    const {
      padding,
      flexorder,
      margin,
      title,
      videoSrc,
      rightText,
      leftText,
      fullWidth,
      centralVideoFallbackImage,
    } = this.props

    const isVideo = getIsVideoFromUrl(videoSrc)

    return (
      <GridCardContainer padding={padding} margin={margin}>
        <GridCardBlock flexorder={flexorder} fullWidth={fullWidth}>
          <PayOff width={fullWidth ? '100%' : undefined}>{title}</PayOff>
          {videoSrc && (
            <LazyLoadedMedia>
              {isVideo ? (
                <VideoCard
                  autoPlay
                  muted
                  loop
                  playsInline
                  poster={centralVideoFallbackImage}
                >
                  <source src={videoSrc} type="video/mp4" />
                </VideoCard>
              ) : (
                <Image src={videoSrc} />
              )}
            </LazyLoadedMedia>
          )}
          {leftText && <div dangerouslySetInnerHTML={{ __html: leftText }} />}
        </GridCardBlock>

        {rightText && (
          <GridCardBlock inverse={flexorder} fullWidth={fullWidth}>
            <div dangerouslySetInnerHTML={{ __html: rightText }} />
          </GridCardBlock>
        )}
      </GridCardContainer>
    )
  }
}

GridCard.propTypes = {
  title: PropTypes.string,
  videoSrc: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  flexorder: PropTypes.number,
  leftText: PropTypes.any,
  rightText: PropTypes.any,
}

export default GridCard
